import { Navigate, Outlet, useNavigate } from 'react-router-dom'
import { urlSplashPage } from 'services/utils/globalVariables';
import { getCookie, setCookie } from 'services/utils/CookieHandler';
import { useEffect, useState } from 'react';
import getExternalPrize from 'services/utils/GetExternalPrize';

//protected and unprotected route

export const ProtectedRoute = ({ setLoad }) => {

    const navigate = useNavigate()

    let auth = null; // determine if authorized, from context or however you're doing it
    const LoginData = getCookie('loginData') && getCookie('loginData') != "undefined" ? getCookie('loginData') : null;

    if (LoginData) {
        auth = LoginData
    }

    if(window.location.href.includes("qr=")) {
        setCookie("prizeData", window.location.href)
        navigate("/")
    }

    return auth ? <Outlet /> : <Navigate to={urlSplashPage} />;

}

export const UnProtectedRoute = () => {
    let auth = null; // determine if authorized, from context or however you're doing it
    const LoginData = getCookie('loginData') && getCookie('loginData') != "undefined" ? getCookie('loginData') : null;

    if (LoginData) {
        auth = LoginData
    }

    return auth ?  <Navigate to={"/"} /> : <Outlet />;
}